import React from "react";
import { classNames } from "../../helpers";

export default function TwContainer(props) {
  const { children, className = "" } = props

  return (
    <div className={classNames("flex-1 p-5 md:px-10 h-full", className)}>
      {children}
    </div>
  );
}
